import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import BusRetenButton from './BusRetenButton';

const RegisteredBusFleetToolbar = ({ onSuccess }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <BusRetenButton onSuccess={onSuccess} />
    </div>
  </ButtonToolbar>
);

RegisteredBusFleetToolbar.propTypes = {
  onSuccess: PropTypes.func,
};

RegisteredBusFleetToolbar.defaultProps = {
  onSuccess: null,
};

export default RegisteredBusFleetToolbar;
